import { render, staticRenderFns } from "./IChart.vue?vue&type=template&id=57f503a0&"
import script from "./IChart.vue?vue&type=script&lang=js&"
export * from "./IChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports